"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Root = void 0;
var react_1 = __importDefault(require("react"));
var MenuTriggerProvider_1 = require("../../provider/MenuTriggerProvider");
var SelectionProvider_1 = require("../../provider/SelectionProvider");
var MenuPopup_1 = require("../MenuPopup/MenuPopup");
var Root = function (_a) {
    var trigger = _a.trigger, children = _a.children, isOpen = _a.isOpen, defaultOpen = _a.defaultOpen, onOpenChange = _a.onOpenChange, isLoading = _a.isLoading, loadingSkeleton = _a.loadingSkeleton, label = _a.label, items = _a.items, selectedKeys = _a.selectedKeys, defaultSelectedKeys = _a.defaultSelectedKeys, onSelectionChange = _a.onSelectionChange, _b = _a.selectionMode, selectionMode = _b === void 0 ? "multiple" : _b, onSearchInputChange = _a.onSearchInputChange;
    var menuTriggerProps = { isOpen: isOpen, defaultOpen: defaultOpen, onOpenChange: onOpenChange };
    var menuPopupProps = { isLoading: isLoading, loadingSkeleton: loadingSkeleton };
    var disabledKeys = new Set(items === null || items === void 0 ? void 0 : items.filter(function (item) { return item.isDisabled === true; }).map(function (disabledItem) { return disabledItem.value; }));
    var selectionProps = {
        label: label,
        items: items,
        selectedKeys: selectedKeys,
        defaultSelectedKeys: defaultSelectedKeys,
        onSelectionChange: onSelectionChange,
        selectionMode: selectionMode,
        disabledKeys: disabledKeys,
        onSearchInputChange: onSearchInputChange
    };
    return (react_1["default"].createElement(MenuTriggerProvider_1.MenuTriggerProvider, __assign({}, menuTriggerProps),
        react_1["default"].createElement("div", null,
            react_1["default"].createElement(MenuTriggerProvider_1.MenuTriggerConsumer, null, trigger),
            react_1["default"].createElement(MenuPopup_1.MenuPopup, __assign({}, menuPopupProps),
                react_1["default"].createElement(SelectionProvider_1.SelectionProvider, __assign({}, selectionProps),
                    react_1["default"].createElement(SelectionProvider_1.SelectionConsumer, null, children))))));
};
exports.Root = Root;
exports.Root.displayName = "Root";
//# sourceMappingURL=Root.js.map